import { countryService } from '@/services/api/country.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { countryModel } from '@/models/api/country.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const COUNTRY_MODULE = "api/country";

// ACTIONS
export const GET_ALL_COUNTRY = 'getAllCountry';
export const CREATE_COUNTRY = 'createCountry';
export const GET_COUNTRY = 'getCountry';
export const UPDATE_COUNTRY = 'updateCountry';
export const UPDATE_COUNTRY_STATUS = 'updateCountryStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_COUNTRY_SUCCESS = "allCountrySuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_COUNTRY_SUCCESS = "getCountrySuccess";

export const actions = {
    [GET_ALL_COUNTRY]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        countryService
            .getAll(filter)
            .then((result) => {
                commit(ALL_COUNTRY_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_COUNTRY]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return countryService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_COUNTRY, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_COUNTRY]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return countryService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_COUNTRY_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_COUNTRY]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return countryService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_COUNTRY, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_COUNTRY_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return countryService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_COUNTRY, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_COUNTRY_SUCCESS](state, {data}) {
        let country = data.data || [];
        state.list.data = country;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = country.map(item => countryModel(item));
        }
    },
    [GET_COUNTRY_SUCCESS](state, data) {
        state.details = countryModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
